import { Serializable } from "./Serializable";

export class Team implements Serializable<Team> {
    teamId: number;
    ownerId: number;
    subjectId: number;
    orgName: string;
    teamPermissions: any;
    placementId: any
    placement: any;
    schoolId: number;
    school: any;
    riskTierId: any;
    riskTier: any;
    gradeId: any;
    grade: any;
    localId: any;
    studentId: any;
    graduationYear: string;
    orgShortName: string;


    // this will be used for casting JSON to object
    deserialize(input) {
        input.teamId && (this.teamId = input.teamId);
        input.id && (this.teamId = input.id);
        input.subjectId && (this.subjectId = input.subjectId);
        input.ownerId && (this.ownerId = input.ownerId);
        input.orgName && (this.orgName = input.orgName);
        input.orgShortName && (this.orgShortName = input.orgShortName);
        input.teamPermissions && (this.teamPermissions = input.teamPermissions);

        input.placementId && (this.placementId = input.placementId);
        input.placement && (this.placement = input.placement);
        input.schoolId && (this.schoolId = input.schoolId);
        input.school && (this.school = input.school);
        input.riskTierId && (this.riskTierId = input.riskTierId);
        input.riskTier && (this.riskTier = input.riskTier);
        input.gradeId && (this.gradeId = input.gradeId);
        input.grade && (this.grade = input.grade);
        input.localId && (this.localId = input.localId);
        input.studentId && (this.studentId = input.studentId);
        input.graduationYear && (this.graduationYear = input.graduationYear);

        return this;
    }


}
